/* eslint-disable no-alert */
/* eslint-disable no-param-reassign */
import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { Modal, StepTracker, Typography } from '@telus-uds/components-web';
import { useTranslationsContext } from '../context/TranslationsContext';
import request, { getEnvironment } from '../utils/request';
// import FormSummaryGroup from '../form/formSummaryGroup';
import EN from '../../EN.json';
import FR from '../../FR.json';
import StepOne from './stepOne';
import StepTwo from './stepTwo';
import StepThree from './stepThree';
import { useLocaleContext } from '../context/LocaleContext';
import { getReferralLang } from './language';

const ReferralForm = ({ history }) => {
  const [fields, setFields] = React.useState({});
  const [step, setStep] = React.useState(0);
  const [isSubmitting, setIsSubmitting] = React.useState(false);
  const [isModalOpen, setIsModalOpen] = React.useState(false);
  const [isSFDCModalOpen, setIsSFDCModalOpen] = React.useState(false);
  const [pendingPayload, setPendingPayload] = React.useState(null);
  const profile = request.getProfile();
  const {
    role: { name },
    firstName = '',
    lastName = '',
    email = '',
    province = ''
  } = profile;
  const local = useLocaleContext();
  const {
    Referform: {
      ReferralForm: ReferralFormLabel,
      SFDCSubmittedTitle,
      SFDCSubmittedBody
    }
  } = local === 'en-US' ? EN : FR;
  const {
    leadQueueConfig: { leadValue },
    name: envName
  } = getEnvironment();
  const { origin } = window.location;
  const translations = useTranslationsContext();
  const {
    REFERRALS: {
      steps,
      modalData,
      customerInformation,
      businessInformation,
      productInformation,
      stepThree: { labels }
    }
  } = translations;

  const [wireline, wireless] = labels.productOfInterestOptions;
  const { productOptionsWireline, productOptionsWireless } = labels;
  const stepNames = [
    customerInformation,
    businessInformation,
    productInformation
  ];

  const getFinalProductsOfInterest = (product, productOfInterest) => {
    let finalProducts = [];

    if (productOfInterest.includes(wireline)) {
      finalProducts = product.filter(value =>
        productOptionsWireline.includes(value)
      );
    }
    if (productOfInterest.includes(wireless)) {
      finalProducts = product.filter(value =>
        productOptionsWireless.includes(value)
      );
    }
    if (
      productOfInterest.includes(wireline) &&
      productOfInterest.includes(wireless)
    ) {
      finalProducts = product;
    }
    return finalProducts;
  };
  const submitReferral = payload => {
    setIsSubmitting(true);
    const salesRepInfo = {
      telusFirstName: firstName,
      telusLastName: lastName,
      telusEmailAddress: email,
      telusPhone: ' ',
      telusProvince: province,
      telusChannel: profile.channel ? profile.channel.name : ' ',
      telusID: profile.xid ? profile.xid : ' '
    };
    const { existingTelusAccount = '', businessAccountNumber = '' } =
      payload || {};
    const referralPayload = {
      ...payload,
      lang: getReferralLang(payload),
      additionalComments: `${payload.additionalComments},${existingTelusAccount},${businessAccountNumber}`
    };
    const payloadWithSalesRepInfo = {
      ...payload,
      ...salesRepInfo
    };
    // setting payloadLeadQueue
    window.localStorage.setItem(
      'payloadLeadQueue',
      JSON.stringify(payloadWithSalesRepInfo)
    );
    request
      .post('/referral/add-referral', referralPayload)
      .then(() => {
        setIsSubmitting(false);
        if (envName === 'prod') {
          document.getElementById('post_SFDC').submit();
          history.push({
            pathname: '/'
          });
        } else {
          setIsSFDCModalOpen(true);
        }
      })
      .catch(error => {
        setIsSubmitting(false);
        throw error;
      });
  };
  const onStepSubmit = stepFields => {
    if (step + 1 > 2) {
      stepFields.product = getFinalProductsOfInterest(
        stepFields.product,
        stepFields.productOfInterest
      );
      stepFields.productOfInterest =
        stepFields.productOfInterest && stepFields.productOfInterest.join(', ');
      setPendingPayload({ ...fields, ...stepFields });
      setIsModalOpen(true);
    } else {
      setFields({ ...fields, ...stepFields });
      setStep(step + 1);
    }
  };

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [step]);

  // getting payloadLeadQueue
  let payloadLeadQueue = {};
  if (JSON.parse(localStorage.getItem('payloadLeadQueue'))) {
    payloadLeadQueue = JSON.parse(localStorage.getItem('payloadLeadQueue'));
  }

  const proceed = () => {
    setIsModalOpen(false);
    if (pendingPayload) {
      submitReferral(pendingPayload);
      setPendingPayload(null);
    }
  };

  const onSFDCSuccess = () => {
    setIsSFDCModalOpen(false);
    return history.push({
      pathname: '/'
    });
  };

  return (
    <>
      <div>
        <div
          style={{
            marginLeft: '9%',
            marginTop: '2%'
          }}
        >
          <Typography heading="h2" variant={{ size: 'h2' }} block>
            {ReferralFormLabel}
          </Typography>
        </div>
      </div>
      <Modal
        heading={modalData.title}
        bodyText={modalData.body}
        confirmButtonText={modalData.confirmText}
        cancelButtonText={modalData.cancelText}
        onConfirm={proceed}
        onClose={() => setIsModalOpen(false)}
        isOpen={isModalOpen}
      />
      <Modal
        heading={SFDCSubmittedTitle}
        bodyText={SFDCSubmittedBody}
        confirmButtonText={modalData.confirmText}
        onConfirm={onSFDCSuccess}
        onClose={onSFDCSuccess}
        isOpen={isSFDCModalOpen}
      />
      <div className="container 85% referral-page">
        <div id="main">
          <div id="main-wrapper">
            <div id="main-content" style={{ marginTop: 20 }}>
              <div
                id="title"
                style={{
                  paddingLeft: 20,
                  paddingTop: 10,
                  marginBottom: 16
                }}
              >
                <Typography heading="h2" variant={{ size: 'h2' }} block>
                  {stepNames[step]}
                </Typography>
              </div>
              <StepTracker current={step} steps={steps} />
              {step === 0 && (
                <StepOne
                  onSubmit={onStepSubmit}
                  stepData={fields}
                  role={name}
                />
              )}
              {step === 1 && (
                <StepTwo
                  onSubmit={onStepSubmit}
                  stepData={fields}
                  role={name}
                />
              )}
              {step === 2 && (
                <StepThree
                  onSubmit={onStepSubmit}
                  stepData={fields}
                  isSubmitting={isSubmitting}
                />
              )}
            </div>
          </div>
        </div>
      </div>
      <form
        style={{ display: 'none' }}
        action="https://cloud.connect.telus.com/sbsreferral_amp/"
        method="POST"
        id="post_SFDC"
      >
        <input type="hidden" name="oid" value={leadValue} />
        <input type="hidden" name="retUrl" value={origin} />
        <input
          type="hidden"
          name="legalBusinessName"
          id="legalBusinessName"
          value={payloadLeadQueue.legalBusinessName || ' '}
        />{' '}
        <br />
        <input
          type="hidden"
          name="firstName"
          id="firstName"
          value={payloadLeadQueue.firstName || ' '}
        />{' '}
        <br />
        <input
          type="hidden"
          name="lastName"
          id="lastName"
          value={payloadLeadQueue.lastName || ' '}
        />{' '}
        <br />
        <input
          type="hidden"
          name="email"
          id="email"
          value={payloadLeadQueue.email || ' '}
        />
        <br />
        <input
          type="hidden"
          name="mobileNumber"
          id="mobileNumber"
          value={payloadLeadQueue.mobileNumber || ' '}
        />
        <br />
        <input
          type="hidden"
          name="province"
          id="province"
          value={payloadLeadQueue.province || ' '}
        />
        <br />
        <input
          type="hidden"
          name="prefferedLanguage"
          id="prefferedLanguage"
          value={payloadLeadQueue.prefferedLanguage || ' '}
        />
        <br />
        <input
          type="hidden"
          name="serviceAddress"
          id="serviceAddress"
          value={payloadLeadQueue.serviceAddress || ' '}
        />
        <br />
        <input
          type="hidden"
          name="isMultiSuite"
          id="isMultiSuite"
          value={payloadLeadQueue.isMultiSuite || ' '}
        />
        <br />
        <input
          type="hidden"
          name="businessType"
          id="businessType"
          value={payloadLeadQueue.businessType || ' '}
        />
        <br />
        <input
          type="hidden"
          name="propertyRoom"
          id="propertyRoom"
          value={payloadLeadQueue.propertyRoom || ' '}
        />
        <br />
        <input
          type="hidden"
          name="noOfEmployees"
          id="noOfEmployees"
          value={payloadLeadQueue.noOfEmployees || ' '}
        />
        <br />
        <input
          type="hidden"
          name="productOfInterest"
          id="productOfInterest"
          value={payloadLeadQueue.productOfInterest || ' '}
        />
        <br />
        <input
          type="hidden"
          name="product"
          id="product"
          value={payloadLeadQueue.product || ' '}
        />
        <br />
        <input
          type="hidden"
          name="additionalComments"
          id="additionalComments"
          value={payloadLeadQueue.additionalComments || ' '}
        />
        <br />
        <input
          type="hidden"
          name="firstNameSalesRep"
          id="firstNameSalesRep"
          value={payloadLeadQueue.telusFirstName || ' '}
        />
        <br />
        <input
          type="hidden"
          name="lastNameSalesRep"
          id="lastNameSalesRep"
          value={payloadLeadQueue.telusLastName || ' '}
        />
        <br />
        <input
          type="hidden"
          name="emailSalesRep"
          id="emailSalesRep"
          value={payloadLeadQueue.telusEmailAddress || ' '}
        />
        <br />
        <input
          type="hidden"
          name="contactNumberSalesRep"
          id="contactNumberSalesRep"
          value={payloadLeadQueue.telusPhone || ' '}
        />
        <br />
        <input
          type="hidden"
          name="provinceSalesRep"
          id="provinceSalesRep"
          value={payloadLeadQueue.telusProvince || ' '}
        />
        <br />
        <input
          type="hidden"
          name="channelSalesRep"
          id="channelSalesRep"
          value={payloadLeadQueue.telusChannel || ' '}
        />
        <br />
        <input
          type="hidden"
          name="xidSalesRep"
          id="xidSalesRep"
          value={payloadLeadQueue.telusID || ' '}
        />
        <br />
        <br />
        <br />
      </form>
    </>
  );
};

ReferralForm.propTypes = {
  history: PropTypes.shape({
    push: PropTypes.func.isRequired
  }).isRequired
};

export default ReferralForm;
